import { Modal } from 'antd'
import React, { useState } from 'react'
import { BoxFirmware } from '.'
import { BoxFirmwareModalProps } from '../interface'

export const BoxFirmwareModal: React.FC<BoxFirmwareModalProps> = (
  props: BoxFirmwareModalProps
) => {
  const { visible, boxItems, onVisibleChange, onFirmwareUpdate } = props
  const [formResult, setFormResult] = useState<boolean>(false)
  return (
    <Modal
      destroyOnClose={true}
      maskClosable={false}
      title='固件更新'
      visible={visible}
      onOk={() => setFormResult(true)}
      onCancel={() => onVisibleChange?.(false)}
      width={650}
    >
      <BoxFirmware
        boxes={boxItems}
        formResult={formResult}
        onFormValidate={() => setFormResult(false)}
        onFormSubmit={onFirmwareUpdate}
      />
    </Modal>
  )
}
